import { z } from "zod";

import { machineTypeSchema } from "../machine-type";
import { machineBaseSchema } from "../machine-base";

export const zebraMachineSchema = machineBaseSchema.extend({
	machineType: z.literal(machineTypeSchema.enum.ZebraPrinter),
	isPeelOff: z.boolean(),
	isPriorityPrinter: z.boolean(),
});

// TODO @eb remove this function when the Zebra aligns with our decided upon schemas
export const prepareZebraMachineData = (data: unknown): unknown => {
	if (typeof data !== "object" || data === null) {
		return data;
	}

	const input = data as Record<string, unknown>;

	const iotDevice = {
		hubName: input.iotHubName ?? "",
		deviceId: input.iotEdgeDeviceId ?? "",
		moduleId: input.iotEdgeModuleId ?? "",
		moduleVersion: input.edgeModuleVersion ?? "",
		lastProofOfLife: input.proofOfLifeUpdated,
	};

	const error = input.error as Record<string, unknown>;
	let stopReason = { stopCode: 0, message: "", arguments: [], isError: false };
	if (typeof error === "object" && error !== null) {
		stopReason = {
			stopCode: (error.code as number) ?? 0,
			message: (error.message as string) ?? "",
			arguments: [],
			isError: error.code !== 0,
		};
	}

	let workstations = input.workstations;
	if (!Array.isArray(workstations) || workstations.length < 1) {
		workstations = [
			{
				number: 1,
				alarms: [
					{
						code: stopReason.stopCode,
						message: stopReason.message,
						arguments: stopReason.arguments.map(String),
					},
				],
				warnings: [],
				stopReason: {
					code: stopReason.stopCode,
					message: stopReason.message,
					arguments: stopReason.arguments.map(String),
					isError: stopReason.isError,
				},
			},
		];
	}

	return {
		...input,
		machineType: "ZebraPrinter",
		assetId: input.assetId ?? "",
		description: input.description ?? "",
		plcVersion: input.plcVersion ?? "",
		iotDevice,
		stopReason,
		activeWarnings: [],
		workstations,
	};
};

export type ZebraMachine = z.infer<typeof zebraMachineSchema>;
